export const isProductMediaVideo = (mediaLink: string): boolean =>
  !!mediaLink?.startsWith('https://cdn.media.amplience.net/v');
